export class EbeJobPosting {
    
}